var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveforumImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_forum_3327115",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.123,
    height: 68.458,
    viewBox: "0 0 86.123 68.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41961",
    "data-name": "Path 41961",
    d: "M18.25,26.459a2.208,2.208,0,0,1,2.208-2.208H51.376a2.208,2.208,0,0,1,0,4.417H20.459A2.208,2.208,0,0,1,18.25,26.459ZM53.584,37.5a2.208,2.208,0,0,0-2.208-2.208H20.459a2.208,2.208,0,1,0,0,4.417H51.376A2.208,2.208,0,0,0,53.584,37.5Zm37.539,0V61.789A6.631,6.631,0,0,1,84.5,68.417H82.293v8.833a2.208,2.208,0,0,1-3.622,1.7L66.027,68.417H44.75a6.631,6.631,0,0,1-6.625-6.625V55.167H30.3L17.717,69.848a2.208,2.208,0,0,1-3.884-1.431V55.167H11.625A6.631,6.631,0,0,1,5,48.539V17.625A6.631,6.631,0,0,1,11.625,11H60.209a6.631,6.631,0,0,1,6.625,6.625v13.25H84.5A6.631,6.631,0,0,1,91.117,37.5ZM60.206,50.75a2.208,2.208,0,0,0,2.208-2.208V17.625a2.208,2.208,0,0,0-2.208-2.208H11.625a2.208,2.208,0,0,0-2.208,2.208V48.542a2.208,2.208,0,0,0,2.208,2.208h4.417a2.208,2.208,0,0,1,2.208,2.208v9.487l9.366-10.924a2.205,2.205,0,0,1,1.675-.771Zm26.5-13.25A2.208,2.208,0,0,0,84.5,35.292H66.834v13.25A6.631,6.631,0,0,1,60.2,55.167H42.536v6.625A2.208,2.208,0,0,0,44.745,64H66.834a2.211,2.211,0,0,1,1.416.512l9.62,8.027V66.2A2.208,2.208,0,0,1,80.084,64H84.5a2.208,2.208,0,0,0,2.208-2.208Z",
    transform: "translate(-5 -11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveforumImg);
export default __webpack_public_path__ + "static/media/liveforum-img.fab2786c28887fb042be59e1f998ee2c.svg";
export { ForwardRef as ReactComponent };